import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, X, Loader2 } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

// value: array of {path, url}
export function ImageUploader({ value = [], onChange, label = "Immagini", testid = "uploader" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    setUploading(true);
    try {
      const added = [];
      for (const file of Array.from(files)) {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        added.push({ path: data.path, url: data.url });
      }
      onChange([...value, ...added]);
      toast.success(`${added.length} immagine/i caricate`);
    } catch (e) {
      toast.error("Errore durante il caricamento");
    } finally { setUploading(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  const removeAt = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      <label className="block text-sm font-medium text-[#1B2A41] mb-2">{label}</label>
      <div className="flex flex-wrap gap-3">
        {value.map((img, i) => (
          <div key={i} className="relative w-24 h-24 rounded-xl overflow-hidden border border-[#DCE6EF] group">
            <img src={mediaUrl(img.url)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => removeAt(i)} className="absolute top-1 right-1 bg-[#7A1F1F] text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`${testid}-remove-${i}`}><X className="w-3 h-3" /></button>
          </div>
        ))}
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading} className="w-24 h-24 rounded-xl border-2 border-dashed border-[#CBD7E2] flex flex-col items-center justify-center text-[#8695A6] hover:border-[#2472C8] hover:text-[#2472C8] transition-colors" data-testid={`${testid}-add`}>
          {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Upload className="w-5 h-5" /><span className="text-[11px] mt-1">Carica</span></>}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden" onChange={(e) => e.target.files.length && handleFiles(e.target.files)} data-testid={`${testid}-input`} />
    </div>
  );
}
